import { Logger } from "../../helpers/Logger";
import { EVENTS, getTrackingId } from "../config/CONSTANTS";

/**
 * @fileoverview Handles tracking events with Google Analytics.
 * @module GoogleAnalytics
 */

export class GoogleAnalyticsTracker {
    constructor(consent) {
        this.init(consent);
    }

    init(consent) {
        // Check if gtag is already loaded
        if (typeof window.gtag === "function") {
            Logger.log("Google Analytics already initialized");
            return;
        }
        // Initialize gtag
		window.dataLayer = window.dataLayer || [];
        // Set gtag function to the window object
        window.gtag = function () { dataLayer.push(arguments); };
        // Set consents based on current user consent
        window.gtag('consent', 'default', {
            'ad_storage': consent ? 'granted' : 'denied',
            'ad_user_data': consent ? 'granted' : 'denied',
            'ad_personalization': consent ? 'granted' : 'denied',
            'analytics_storage': consent ? 'granted' : 'denied'
        });

        // Add the gtag.js script tag
        const GA_MEASUREMENT_ID = getTrackingId("GA_Measurement");
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);
        // Initialize gtag with the measurement ID
		window.gtag('js', new Date());
		window.gtag('config', GA_MEASUREMENT_ID);

        // Log initialization with ID and consent.
        Logger.log("Google Analytics initialized with ID:", GA_MEASUREMENT_ID);
        Logger.log("Google Analytics consent set to:", consent ? 'granted' : 'denied');

        // Check for a Youtube Pixel ID and initialize if it exists
        const YOUTUBE_PIXEL_ID = getTrackingId("Youtube_Pixel");
        if ( YOUTUBE_PIXEL_ID ) {
            window.gtag('config', YOUTUBE_PIXEL_ID);
            Logger.log("Youtube Pixel initialized with ID:", YOUTUBE_PIXEL_ID);
        }
    }

    // Change consent settings
    updateConsent(consent) {
        if (typeof window.gtag !== "function") {
            Logger.warn("Google Analytics (gtag) not found");
            return;
        }

        // Update consent settings
        window.gtag('consent', 'update', {
            'ad_storage': consent ? 'granted' : 'denied',
            'ad_user_data': consent ? 'granted' : 'denied',
            'ad_personalization': consent ? 'granted' : 'denied',
            'analytics_storage': consent ? 'granted' : 'denied'
        });

        Logger.log("Google Analytics consent updated to:", consent ? 'granted' : 'denied');
    }

    // Track events
    trackEvent(eventType, eventData) {
        if (typeof window.gtag !== "function") {
            Logger.warn("Google Analytics (gtag) not found");
            return;
        }

        const gtagEventType = EVENTS[eventType] || eventType;

        try {
            window.gtag("event", gtagEventType, eventData);
            Logger.log("Google Analytics event tracked:", gtagEventType, eventData);
        } catch (error) {
            Logger.error("Error tracking Google Analytics event:", error);
        }
    }
}
